module.exports = __webpack_public_path__ + "static/media/Coves-of-Northville-Master-Deed.b6d23c5a.pdf";